jQuery(document).ready(function($) {

    // =================================
    // === Register form validations ===
    // =================================

    // Remove invalid class on input change
    // $('.woocommerce-form-register input, .woocommerce-form-login input').on('input', function () {

    //     if ($(this).val() !== '') {
    //         $(this).closest('.input-group').removeClass('invalid');
    //     }
    // });

    // Toggle visibility of proessional fields based on user type selection
    // $('.register-form-wrap .user_type').change(function () {
    //     let user_type = $('.user_type:checked').val();

    //     if (user_type == 'individual') {
    //         $('#reg_first_name, #reg_last_name, #reg_company').removeClass('required');
    //     } else {
    //         $('#reg_first_name, #reg_last_name, #reg_company').addClass('required');
    //     }
    // });

    // Update password length indicator
    // $('.input-password').on('input', function () {
    //     const length = $(this).val().length;
    //     $('.number-password').text(`${length}/8`);
    // });

    // Form submit
    // $(".woocommerce-form-register").submit(function(e) {

    //     let isValid = true;

    //     $requiredInputs = $(this).find('input.required, #reg_password');

    //     $passwordInput = $(this).find('#reg_password');

    //     // Limpiar mensajes previos
    //     $requiredInputs.each(function(_, input) {
    //         $(input).closest('.input-group').removeClass('invalid');
    //     });

    //     // Validar todos los inputs que sean required
    //     $requiredInputs.each(function(_, input) {
            
    //         if (!$(input).val()) {

    //             $(input).closest('.input-group').addClass('invalid');
    //             isValid = false;
    //         }
    //     });

    //     // Validación especial de contraseña
    //     if ($passwordInput.val().length < 8) {
            
    //         $passwordInput.closest('.input-group').addClass('invalid');
    //         isValid = false;
    //     }

    //     if (!isValid){
    //         return false;
    //     }
    // });

    // ==============================
    // === Login form validations ===
    // ==============================

    // Email pattern validation
    // $('#username').change(function () {
        
    //     const emailPattern = /^[a-zA-Z0-9._%+/-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //     const emailInput = $(this);

    //     if (emailPattern.test(emailInput.val())) {
    //         emailInput.closest('.input-group').removeClass('invalid');
    //     } else {
    //         emailInput.closest('.input-group').addClass('invalid');
    //     }
    // });

    // Form submit
    // $('.woocommerce-form-login').submit(function(e) {
        
    //     let isValid = true;

    //     $requiredInputs = $(this).find('input.required');

    //     // Limpiar mensajes previos
    //     $requiredInputs.each(function(_, input) {
    //         $(input).closest('.input-group').removeClass('invalid');
    //     });

    //     // Validar todos los inputs que sean required
    //     $requiredInputs.each(function(_, input) {
            
    //         if (!$(input).val()) {

    //             $(input).closest('.input-group').addClass('invalid');
    //             $(input).siblings('.error-message').show();

    //             isValid = false;
    //         }
    //     });

    //     if (!isValid){
    //         return false;
    //     }
    // });

    // =====================================
    // === Lost password form validation ===
    // =====================================
    // $('.woocommerce-form-lost-password').submit(function(e) {
        
    //     let isValid = $(this).find('input[type="email"]').val() !== '';

    //     const emailInput = $(this).find('input[type="email"]');

    //     if (!isValid){
    //         emailInput.closest('.input-group').addClass('invalid');
    //         return false;
    //     }
    // });

    // ======================================
    // === Order tracking form validation ===
    // ======================================
    // $(".woocommerce-form-track-order").submit(function(e) {

    //     let isValid = true;

    //     $requiredInputs = $(this).find('input.required');

    //     // Limpiar mensajes previos
    //     $requiredInputs.each(function(_, input) {
    //         $(input).closest('.input-group').removeClass('invalid');
    //     });

    //     // Validar todos los inputs que sean required
    //     $requiredInputs.each(function(_, input) {
            
    //         if (!$(input).val()) {

    //             $(input).closest('.input-group').addClass('invalid');
    //             isValid = false;
    //         }
    //     });

    //     if (!isValid){
    //         return false;
    //     }
    // });

    // TODO: LLamada ajax para obtener los datos de seguimiento del pedido y mostrar info en modal (no hay diseño aún)
});